export const PRJ_STATUS = {
  draft: { label: 'Ciornă', cls: 'text-zinc-300 bg-zinc-500/10 border-zinc-500/20' },
  under_review: { label: 'În analiză', cls: 'text-violet-300 bg-violet-500/10 border-violet-500/20' },
  active: { label: 'Activ', cls: 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20' },
  suspended: { label: 'Suspendat', cls: 'text-amber-400 bg-amber-500/10 border-amber-500/20' },
  completed: { label: 'Finalizat', cls: 'text-blue-400 bg-blue-500/10 border-blue-500/20' },
  warranty: { label: 'Garanție', cls: 'text-cyan-400 bg-cyan-500/10 border-cyan-500/20' },
  closed: { label: 'Închis', cls: 'text-zinc-400 bg-zinc-500/10 border-zinc-500/20' },
};

export const PRJ_FLOW = {
  draft: ['under_review', 'active'], under_review: ['draft', 'active'],
  active: ['suspended', 'completed'], suspended: ['active', 'completed'],
  completed: ['warranty', 'closed'], warranty: ['closed'], closed: [],
};

export const money = (v, c = 'RON') => v == null ? '—' : `${Number(v).toLocaleString('ro-RO')} ${c}`;
